import * as React from 'react'
import { DraftEditorConnected } from './DraftEditorConnected'
import { Provider } from 'react-redux'
import { mockState, createMockStore } from 'mockState'

export const DraftEditorExamples = () => {
  return (
    <div className="DraftEditorExamples exampleContainer">
      <h1 className="exampleHeader">default</h1>

      <Provider store={createMockStore(mockState)}>
        <DraftEditorConnected />
      </Provider>
    </div>
  )
}
